const baseAllowedCharacters = /^[A-Za-z\s']+$/i;
const cityAllowedCharacters = /^[A-Za-z\s']+$/u;
const addressAllowedCharacters = /^[A-Za-z0-9\s']+$/u;
const emailAllowedCharacters = /^[A-Za-z0-9-.@_+-]+$/u;

export const filterNonFrenchCharacters = (input: unknown): boolean => {
  return baseAllowedCharacters.test(input as string) || input === '';
};

export const filterNonFrenchCharactersCities = (input: unknown): boolean => {
  return cityAllowedCharacters.test(input as string) || input === '';
};

export const filterNonFrenchCharactersAddresses = (input: unknown): boolean => {
  return addressAllowedCharacters.test(input as string) || input === '';
};

export const filterEmailNonFrenchCharacters = (input: unknown): boolean => {
  return emailAllowedCharacters.test(input as string) || input === '';
};
